<script setup lang="ts">
defineOptions({ name: "AppLayout" });
import { storeToRefs } from "pinia";
import Sidebar from "./components/Sidebar/index.vue";
import Navbar from "./components/Navbar/index.vue";
import AppMain from "./components/AppMain.vue";
import { usePageMaximizeStore } from "@shared/store/modules/pageMaximize";

const { active: isPageMaximized } = storeToRefs(usePageMaximizeStore());
</script>

<template>
    <div class="app-wrapper" :class="{ 'app-wrapper--page-maximized': isPageMaximized }">
        <slot name="sidebar">
            <Sidebar v-show="!isPageMaximized" class="sidebar-container" />
        </slot>
        <div class="main-container">
            <slot name="navbar">
                <Navbar v-show="!isPageMaximized" class="navbar-container" />
            </slot>
            <AppMain class="app-main" :class="{ 'app-main--page-maximized': isPageMaximized }" />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.app-wrapper {
    position: relative;
    width: 100%;
    height: 100%;

    @include clearfix;
}

.sidebar-container {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: var(--layout-sidebar-z-index);
    width: var(--layout-sidebar-width);
    background-color: var(--main-background);
    transition: width var(--transition-base);
}

.main-container {
    position: relative;
    min-height: 100%;
    margin-left: var(--layout-sidebar-width);
    background-color: var(--main-background-active);
    transition: margin-left var(--transition-base);
}

.navbar-container {
    position: sticky;
    top: 0;
    z-index: 100;
}

.app-wrapper--page-maximized {
    .main-container {
        margin-left: 0;
    }
}
</style>
